module.exports = __webpack_public_path__ + "img/palestine-en.dbeb5889.png";